/**
 * Proffeo Design System — chart series colors for time report / absence charts.
 * SSOT CSS variables live in proffeo-tokens.css (`--proffeo-chart-*`).
 * Each hours/absence type owns a unique token — never shared or derived from another color.
 */

export const PROFFEO_CHART_COLORS = {
  standard: 'var(--proffeo-chart-standard)',
  bankPlus: 'var(--proffeo-chart-bank-plus)',
  overtime50: 'var(--proffeo-chart-overtime-50)',
  overtime100: 'var(--proffeo-chart-overtime-100)',
  holiday: 'var(--proffeo-chart-holiday)',
  sickLeave: 'var(--proffeo-chart-sick-leave)',
  sickLeaveChild: 'var(--proffeo-chart-sick-leave-child)',
  publicHoliday: 'var(--proffeo-chart-public-holiday)',
  overtimeMinus: 'var(--proffeo-chart-overtime-minus)',
  hoursBankMinus: 'var(--proffeo-chart-hours-bank-minus)',
  other: 'var(--proffeo-chart-other)'
} as const;

const CSS_VAR_REFERENCE_PATTERN = /^var\((--[\w-]+)\)$/;

/**
 * Resolves a `PROFFEO_CHART_COLORS` token (e.g. `var(--proffeo-chart-standard)`) to its
 * computed literal color value.
 *
 * Chart.js draws bars and legend dots on a `<canvas>`, and `fillStyle`/`strokeStyle` cannot
 * resolve CSS custom properties the way regular styled DOM elements do — passing the raw
 * `var(...)` string silently renders black. Call this right before handing a color to Chart.js.
 */
export function resolveProffeoChartColor(colorToken: string): string {
  const match = CSS_VAR_REFERENCE_PATTERN.exec(colorToken.trim());
  if (!match || typeof document === 'undefined') {
    return colorToken;
  }

  const resolved = getComputedStyle(document.documentElement).getPropertyValue(match[1]).trim();
  return resolved || colorToken;
}
